import useSWRMutation from "swr/mutation";
import { mutateRequest, postFetcher } from "@/lib/swr";
import { useToast } from "@/hooks/use-toast";
import { toastError } from "@/lib/toast";

export const useRemoveFromApp = (engagementId: string, prdId: string) => {
  const { toast } = useToast();
  const refresh = () => {
    mutateRequest("/engagements");
    mutateRequest("/me/inbox");
    mutateRequest("/prds");
    mutateRequest(`/prds/${prdId}`);
    mutateRequest(`/prds/${engagementId}`);
  };
  const { trigger: remove, isMutating: removing } = useSWRMutation(
    `/prds/${engagementId}/remove`,
    postFetcher,
    {
      onSuccess: refresh,
      onError: (e: unknown) =>
        toastError(toast, "移除失败", e, "Remove failed"),
    }
  );
  return {
    remove: () => remove({}),
    isMutating: removing,
  };
};
